import React from "react";

const Datetime = ({dateTime}) => {
    return <nobr>{dateTime}</nobr>;
};

export default Datetime;
